export const etherscanSvg = (
  <svg
    data-testid="ock-etherscanSvg"
    role="img"
    aria-label="Etherscan"
    width="100%"
    height="100%"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Etherscan</title>
    <path
      d="M2.4981 5.70643C2.4981 5.42947 2.72562 5.20195 3.0021 5.20195H3.85218C4.12914 5.20195 4.36626 5.42947 4.36626 5.71651V8.92243C4.46514 8.89267 4.5837 8.86291 4.72242 8.83315C4.9101 8.78371 5.04882 8.61571 5.04882 8.41747V4.43971C5.04882 4.16275 5.27634 3.92515 5.5629 3.92515H6.41298C6.68994 3.92515 6.92706 4.15267 6.92706 4.43971V8.13091C6.92706 8.13091 7.1349 8.04163 7.34226 7.95283C7.50066 7.88371 7.59954 7.73539 7.59954 7.55683V3.15379C7.59954 2.87683 7.82706 2.63923 8.10402 2.63923H8.9541C9.23106 2.63923 9.45858 2.86675 9.45858 3.15379V6.78547C10.1901 6.25123 10.9418 5.60803 11.5351 4.83619C11.7131 4.60867 11.7626 4.31155 11.6637 4.03459C10.576 0.907872 7.15554 -0.754848 4.03122 0.333792C0.906903 1.42243 -0.753897 4.84579 0.333303 7.97299C0.451863 8.32915 0.610263 8.66563 0.797943 8.99203C0.946263 9.24931 1.22322 9.39763 1.51986 9.36787C1.67826 9.35779 1.87602 9.33811 2.12274 9.30835C2.34018 9.28867 2.49858 9.10051 2.49858 8.88259L2.4981 5.70643Z"
      className="fill-ock-primary"
    />
    <path
      d="M2.47852 10.8519C5.15788 12.8012 8.90524 12.2074 10.8526 9.52613C11.5942 8.49701 11.9993 7.26005 11.9993 5.99381C11.9993 5.85509 11.9892 5.71685 11.9796 5.57812C9.79516 8.85317 5.75116 10.3868 2.47852 10.8519Z"
      className="fill-ock-primary"
    />
  </svg>
);
